import * as Yup from "yup";
import {AddressItem, NewPlanAddressForm, NewPlanRubricForm, RubricItem} from "../../../../../types/newPlanItem";
import {useTranslation} from "react-i18next";


export const initialAddressItem: AddressItem = {
    id: null,
    katoCode: "",
    region: "",
    district: "",
    city: "",
    village: "",
    street: "",
    building: "",
}

export const initialValues: NewPlanAddressForm = {
    items: [initialAddressItem],
};

export function ValidationSchema() {
    const {t} = useTranslation();
    return Yup.object({
        items: Yup.array().of(
            Yup.object().shape({
                id: Yup.number().nullable(),
                region: Yup.string().required(t("validation.required")),
                district: Yup.string().nullable(),
                street: Yup.string().required(t("validation.required")),
                city: Yup.string().nullable(),
                village: Yup.string().nullable(),
                building: Yup.string().nullable(),
            }))
    }).required();
}